import React from "react";
import Button from "../../../components/Button";
export default function Template4({ data }) {
  if (!data) return <p>No data found for Blog</p>;
  return (
    <>
      <div>
        {data.MainHeading && <h1>{data.MainHeading}</h1>}
        {data.Mainp && (
          <>
            {data.Mainp.map((p) => (
              <>
                <p>{p.p1}</p>
                <p>{p.p2}</p>
              </>
            ))}
          </>
        )}
        {data.IntroductionP && <p>{data.IntroductionP}</p>}
        {data.Subheading1 && (
          <>
            <h3>{data.Subheading1}</h3>
          </>
        )}
        {data.Subp1 && <p>{data.Subp1}</p>}
        {data.ul &&
          data.ul.map((li) => (
            <>
              <ul>{li.li && <li>{li.li}</li>}</ul>
            </>
          ))}
        {data.Sub1p2 && <p>{data.Sub1p2}</p>}
        {data.Subheading2 && <h3>{data.Subheading2}</h3>}
        {data.Sub2p1 && <p>{data.Sub2p1}</p>}
        {data.ul2 && (
          <ul>
            {data.ul2 &&
              data.ul2.map((li) => (
                <>
                  <ul>{li.li && <li>{li.li}</li>}</ul>
                </>
              ))}
          </ul>
        )}
        {data.Sub2p2 && <p>{data.Sub2p2}</p>}
        {data.Subheading3 && <h3>{data.Subheading3}</h3>}
        {data.Sub3p1 && <p>{data.Sub3p1}</p>}
        {data.table1 && (
          <>
            <table className="table table-bordered align-middle">
              <thead>
                <tr>
                  {data.Column.map((col) => (
                    <>
                      {col.col1 && <th>{col.col1}</th>}
                      {col.col2 && <th>{col.col2}</th>}
                      {col.col3 && <th>{col.col3}</th>}
                      {col.col4 && <th>{col.col4}</th>}
                      {col.col5 && <th>{col.col5}</th>}
                      {col.col6 && <th>{col.col6}</th>}
                    </>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr>
                  {data.Row1.map((row1) => (
                    <>
                      {row1.cell1 && <th>{row1.cell1}</th>}
                      {row1.cell2 && <td>{row1.cell2}</td>}
                      {row1.cell3 && <td>{row1.cell3}</td>}
                      {row1.cell4 && <td>{row1.cell4}</td>}
                    </>
                  ))}
                </tr>
                <tr>
                  {data.Row2.map((row) => (
                    <>
                      {row.cell1 && <th>{row.cell1}</th>}
                      {row.cell2 && <td>{row.cell2}</td>}
                      {row.cell3 && <td>{row.cell3}</td>}
                      {row.cell4 && <td>{row.cell4}</td>}
                    </>
                  ))}
                </tr>
                <tr>
                  {data.Row3.map((row) => (
                    <>
                      {row.cell1 && <th>{row.cell1}</th>}
                      {row.cell2 && <td>{row.cell2}</td>}
                      {row.cell3 && <td>{row.cell3}</td>}
                      {row.cell4 && <td>{row.cell4}</td>}
                    </>
                  ))}
                </tr>
                <tr>
                  {data.Row4.map((row) => (
                    <>
                      {row.cell1 && <th>{row.cell1}</th>}
                      {row.cell2 && <td>{row.cell2}</td>}
                      {row.cell3 && <td>{row.cell3}</td>}
                      {row.cell4 && <td>{row.cell4}</td>}
                    </>
                  ))}
                </tr>
              </tbody>
            </table>
          </>
        )}
        {data.Subheading4 && <h3>{data.Subheading4}</h3>}
        {data.Sub4p1 && <p>{data.Sub4p1}</p>}
        {data.Sub4UL && (
          <>
            {data.Sub4UL.map((item) => (
              <>
                <ul>{item.li && <li>{item.li}</li>}</ul>
              </>
            ))}
          </>
        )}
        <div className=" btn-group">
          {data.WhatsAppbutton && (
            <button
              className="btn btn-primary"
              onClick={() =>
                window.open("https://wa.me/+27630680075", "_blank")
              }
            >
              WhatsApp
            </button>
          )}
        </div>
        <div className=" btn-group m-2">
          {data.Emailbutton && (
            <button
              className="btn btn-primary"
              onClick={() =>
                window.open("mailto:apply@webridge.co.za", "_blank")
              }
            >
              Email
            </button>
          )}
        </div>
        {data.Subheading5 && <h3>{data.Subheading5}</h3>}
        {data.Sub5p && (
          <>
            {data.Sub5p.map((p) => (
              <>
                <p>{p.p}</p>
              </>
            ))}
          </>
        )}
      </div>
    </>
  );
}
